import apiFetch from '../apiFetch'

export default function (documentId, sheetId, token, multipleSignCancel, comment) {
  return apiFetch({ endPoint: `Document/${documentId}/ForceCancelSign?sheetId=${sheetId}&multipleSign=${multipleSignCancel || false}`, method: 'PUT', body: comment, token: token })
}
